import { PageContainer } from '../../../shared/PageContainer';
import ListIcon from '@mui/icons-material/List';
import { listAndDetailSamplesRoutes } from "../../ListAndDetailSamplesNavigation";
import { CityTownDto } from "../../../sampleData/sampleDataReducer";
import { useSampleData } from "../../../sampleData/useSampleData";
import { Box, Button, ButtonProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ListAndDetailSamplesCustomizePageInfo } from './ListAndDetailSamplesCustomizePageInfo';
import { ListAndDetail } from "@sis/react-library"

export const ListAndDetailSamplesCustomizePage = () => {

  const { cityTowns } = useSampleData();

  const navigate = useNavigate();

  const handleView = async (item: CityTownDto) => {
    navigate(`${listAndDetailSamplesRoutes.view}${item.code}`);
  }

  const handleEdit = async (item: CityTownDto) => {
    navigate(`${listAndDetailSamplesRoutes.edit}${item.code}`);
  }

  const buttonProps: ButtonProps = {
    variant: 'outlined',
    size: 'small',
    sx: { height: '20px', padding: 0, margin: '0 0 0 4px' }
  }

  // If you don't specify any searchFields - the search box doens't show
  // If you don't specify a newUrl, the new button doesn't show
  // If you don't specify an onDeleting function, the delete checkboxes and delete button doesn't show
  // If you don't specify an editUrl, then clicking the button does nothing, you have to take care of that functionality
  // yourself. (In this example buttons are added to each list item).
  // This example shows all these things.

  const listItemRender = (item: CityTownDto) =>
    <Box sx={{ borderBottom: '1px solid rgb(240, 240, 240)', width: '100%', paddingTop: '10px' }}>
      <Box sx={{ position: 'relative', width: '100%', height: '30px' }}>
        {item.description}
        <Box sx={{ position: 'absolute', top: -4, right: 0 }}>
          <Button
            id={`${item.code}-view`} {...buttonProps} color='secondary'
            onClick={() => handleView(item)}>
            View
          </Button>
          <Button
            id={`${item.code}-edit`}{...buttonProps} color='success'
            onClick={() => handleEdit(item)}>
            Edit
          </Button>
        </Box>
      </Box>
    </Box>

  return (
    <PageContainer
      heading='List Samples - Customize'
      icon={<ListIcon />}
      pageInfo={<ListAndDetailSamplesCustomizePageInfo />}
      wrapRightElementForMobile={false}
    >
      <ListAndDetail
        items={cityTowns}
        keyValue={(item) => item.code}
        itemRender={listItemRender}
        // Below used for checking which urls to use to obtain the selected item
        additionalUrlsToCheckForSelecting={[listAndDetailSamplesRoutes.view, listAndDetailSamplesRoutes.edit]}
        listUrl={listAndDetailSamplesRoutes.customize}
        listWidths={{ forInitialState: '500px', forURLSelected: '400px' }}  // This is for desktop only, defaults to 400px and 300px.
      />
    </PageContainer>
  )
}
